<template>
  <div id="new-lgb-team-members-list">
    <v-card elevation="0" class="lgb-shell">
      <!-- Header Section -->
      <div class="premium-header">
        <span class="header-orb orb-1"></span>
        <span class="header-orb orb-2"></span>
        <span class="header-orb orb-3"></span>
        <div class="header-inner">
          <div class="header-left">
            <div class="glass-icon">
              <v-icon color="white">mdi-account-group</v-icon>
            </div>
            <div class="header-text">
              <h2 class="header-title">{{ PageTitle }} {{ NextYearName }}</h2>
              <div class="header-subtitle">
                {{ PageDescription }} {{ NextYearName }}
              </div>
            </div>
          </div>

          <v-btn
            depressed
            class="glass-btn white--text font-weight-medium px-4"
            @click.prevent="refreshPageData"
          >
            <v-icon left>mdi-refresh</v-icon>
            Refresh
          </v-btn>
        </div>
      </div>
      <!-- Floating Action Button -->
      <v-container class="py-0" v-if="floatButtonFlag">
        <v-speed-dial
          v-if="floatButtonFlag"
          v-model="fab"
          :top="top"
          :bottom="bottom"
          :right="right"
          :left="left"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
          :fixed="true"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="primary" dark fab>
              <v-icon v-if="fab"> mdi-close </v-icon>
              <v-icon v-else> mdi-account-circle </v-icon>
            </v-btn>
          </template>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="indigo"
                @click.prevent="addRecordPrompt = true"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <span>Assign member</span>
          </v-tooltip>
          <v-tooltip left v-if="addJcrtButtonFlag">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="success"
                @click.prevent="OpenNewMemberDialog(1)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-star</v-icon>
              </v-btn>
            </template>
            <span>Add Jcrt member</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="info"
                @click.prevent="OpenNewMemberDialog(2)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-account-child</v-icon>
              </v-btn>
            </template>
            <span>Add JrJc member</span>
          </v-tooltip>
        </v-speed-dial>
      </v-container>

      <!-- Dialogs -->
      <v-dialog v-model="addRecordPrompt" persistent max-width="70%">
        <new-lgb-team-members-modify
          pageDescription="Assign LO Governing board members for the year"
          :addRecordPrompt="addRecordPrompt"
          @hideAddRecordPrompt="hideAddRecordPrompt($event)"
          v-if="addRecordPrompt"
        ></new-lgb-team-members-modify>
      </v-dialog>

      <v-dialog v-model="editRecordPrompt" persistent max-width="80%">
        <new-lgb-team-members-edit
          pageDescription="Edit LO Governing board members for the year"
          :editRecordPrompt="editRecordPrompt"
          :recordData="selectedData"
          @hideEditRecordPrompt="hideEditRecordPrompt"
          v-if="editRecordPrompt"
        ></new-lgb-team-members-edit>
      </v-dialog>

      <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
        <add-member-document
          pageTitle="Add Member Document"
          pageDescription="Add Member Document"
          :showDialog="memberDocumentPrompt"
          @hideDialog="hideMemberDocumentPrompt"
          v-if="memberDocumentPrompt"
        ></add-member-document>
      </v-dialog>

      <v-dialog v-model="uploadDocumentPrompt" persistent max-width="70%">
        <add-lom-document
          pageTitle="Upload Nomination committee report"
          pageDescription="Upload Nomination committee report"
          :addRecordPrompt="uploadDocumentPrompt"
          @hideAddRecordPrompt="hideUploadRecordPrompt($event)"
          v-if="uploadDocumentPrompt"
        ></add-lom-document>
      </v-dialog>

      <v-dialog v-model="createRecordPrompt" persistent scrollable>
        <create-new-member
          :pageDescription="NewMemberPageDescription"
          :MemberType="NewMemberType"
          :addRecordPrompt="createRecordPrompt"
          @hideAddRecordPrompt="hideCreateRecordPrompt($event)"
          v-if="createRecordPrompt"
        ></create-new-member>
      </v-dialog>

      <v-dialog
        eager
        v-model="previewRecordPrompt"
        v-if="PreviewButtonFlag && Documentpath != ''"
        max-width="1100"
        content-class="premium-dialog"
      >
        <v-card class="premium-dialog-card">
          <div class="premium-header premium-header--dialog">
            <span class="header-orb orb-1"></span>
            <span class="header-orb orb-2"></span>
            <div class="header-inner">
              <div class="header-left">
                <div class="glass-icon glass-icon--sm">
                  <v-icon color="white" small>mdi-file-eye-outline</v-icon>
                </div>
                <div class="header-text">
                  <div class="header-title header-title--sm">
                    Nomination List
                  </div>
                  <div class="header-subtitle">
                    Uploaded Nomination committee report
                  </div>
                </div>
              </div>
              <v-btn icon dark @click="hidePreviewRecordPrompt">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="preview-body">
            <div class="preview-frame">
              <iframe
                id="ifrm"
                :src="Documentpath"
                v-if="PreviewButtonFlag && Documentpath != ''"
                width="100%"
                height="500px"
              ></iframe>
            </div>
            <v-card v-if="!PreviewButtonFlag" width="100%" height="500px">
              <v-row wrap>
                <v-col cols="12" md="12" align="center">
                  <h1 class="text-danger">File not found.</h1>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-card-text class="lgb-body">
        <!-- Loading Spinner -->
        <div class="d-flex justify-center my-4" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            color="primary"
            size="70"
            width="7"
          >
            Loading
          </v-progress-circular>
        </div>

        <!-- Steps to complete -->
        <div class="premium-card fade-up delay-1 mb-6">
          <div class="card-head">
            <div class="icon-badge">
              <v-icon small color="white">mdi-format-list-numbered</v-icon>
            </div>
            <div class="card-head-title">
              Steps to complete the LO Governing Board
            </div>
          </div>

          <div class="stepper">
            <div
              class="step"
              :class="{
                'step--pending': KeyPostStatus.some(
                  (post) => !post.AssignedFlag
                ),
              }"
            >
              <div class="step-marker">
                <span class="step-circle">1</span>
              </div>
              <div class="step-card">
                <div class="step-title">Assign key office bearers</div>
                <div class="step-text">
                  First assign the <b>President</b>, <b>Secretary</b> and
                  <b>IPP</b> using the
                  <span class="inline-tag tag-success">Assign Member</span>
                  button. Their names are auto-filled in the nomination
                  committee report.
                </div>
                <div class="step-footer">
                  <span
                    v-for="post in KeyPostStatus"
                    :key="post.DesignationId"
                    class="pill-chip"
                    :class="
                      post.AssignedFlag
                        ? 'pill-chip--done'
                        : 'pill-chip--pending'
                    "
                  >
                    <v-icon
                      x-small
                      class="mr-1"
                      :color="post.AssignedFlag ? '#16a34a' : '#b45309'"
                    >
                      {{
                        post.AssignedFlag
                          ? "mdi-check-circle"
                          : "mdi-clock-outline"
                      }}
                    </v-icon>
                    {{ post.Name }}
                  </span>
                </div>
              </div>
            </div>

            <div class="step">
              <div class="step-marker">
                <span class="step-circle">2</span>
              </div>
              <div class="step-card">
                <div class="step-title">Download the report</div>
                <div class="step-text">
                  Download the Nomination committee report, fill the committee
                  member details and get it signed by the Nomination Committee
                  Chairman.
                </div>
                <div class="step-footer">
                  <a
                    href="#"
                    @click.prevent="downloadNominationReport"
                    class="outline-link"
                  >
                    <v-icon x-small color="primary" class="mr-1"
                      >mdi-download</v-icon
                    >
                    Nomination committee report
                    <v-progress-circular
                      v-if="ReportLoadingFlag"
                      indeterminate
                      color="primary"
                      size="14"
                      width="2"
                      class="ml-2"
                    ></v-progress-circular>
                  </a>
                </div>
              </div>
            </div>

            <div class="step" :class="{ 'step--pending': !Documentpath }">
              <div class="step-marker">
                <span class="step-circle">3</span>
              </div>
              <div class="step-card">
                <div class="step-title">Upload the signed report</div>
                <div class="step-text">
                  Upload the signed copy using the
                  <span class="inline-tag tag-teal"
                    >Upload Nomination committee report</span
                  >
                  button.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="premium-card fade-up delay-2 mb-6">
          <v-row align="center" class="pa-4" no-gutters>
            <v-col cols="12" lg="8">
              <div class="action-toolbar">
                <v-btn
                  class="action-btn btn-shine"
                  color="success"
                  depressed
                  @click.prevent="addRecordPrompt = true"
                >
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  Assign Member
                </v-btn>

                <v-btn
                  class="action-btn white--text"
                  color="deep-purple"
                  depressed
                  @click.prevent="memberDocumentPrompt = true"
                  v-if="MemberDocumentFlag"
                >
                  <v-icon left>mdi-file-upload</v-icon>
                  Upload Age Proof Document
                </v-btn>

                <v-btn
                  v-if="Flag"
                  class="action-btn white--text"
                  color="orange darken-1"
                  depressed
                  @click.prevent="OpenNewMemberDialog(2)"
                >
                  <v-icon left>mdi-account-child</v-icon>
                  Add Jr. Jc Member
                </v-btn>

                <v-btn
                  class="action-btn btn-shine white--text"
                  color="teal"
                  depressed
                  @click.prevent="uploadDocumentPrompt = true"
                >
                  <v-icon left>mdi-file-document-outline</v-icon>
                  Upload Nomination committee report
                </v-btn>

                <v-btn
                  class="action-btn white--text"
                  color="teal"
                  depressed
                  @click.prevent="uploadRecordPrompt = true"
                  v-if="CreateButtonFlag"
                >
                  <v-icon left>mdi-file-upload-outline</v-icon>
                  Upload Nomination Report
                </v-btn>

                <v-btn
                  class="action-btn white--text"
                  color="amber darken-2"
                  depressed
                  @click.prevent="previewRecordPrompt = true"
                  v-if="PreviewButtonFlag && Documentpath != ''"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Preview Report
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" lg="4">
              <div
                class="kpi-card"
                :class="Documentpath ? 'kpi-card--done' : 'kpi-card--pending'"
              >
                <div class="d-flex align-center">
                  <div class="kpi-avatar">
                    <v-icon :color="Documentpath ? '#16a34a' : '#f59e0b'">
                      mdi-file-document-outline
                    </v-icon>
                  </div>
                  <div>
                    <div class="kpi-label">Nomination committee report</div>
                    <div class="kpi-sub">Upload status</div>
                  </div>
                </div>

                <transition name="chip-pop" mode="out-in">
                  <v-chip
                    :key="Documentpath ? 'done' : 'pending'"
                    :color="Documentpath ? 'success' : 'warning'"
                    label
                    small
                    text-color="white"
                    class="status-chip font-weight-medium"
                  >
                    <v-icon left small>
                      {{
                        Documentpath ? "mdi-check-circle" : "mdi-alert-circle"
                      }}
                    </v-icon>
                    {{ Documentpath ? "Completed" : "Pending" }}
                  </v-chip>
                </transition>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Team Members Grid -->
        <div class="premium-card fade-up delay-3 mb-6" v-if="rows.length > 0">
          <div class="card-head">
            <div class="icon-badge">
              <v-icon small color="white">mdi-account-group</v-icon>
            </div>
            <div class="card-head-title">LO Governing Board Members</div>
            <v-spacer></v-spacer>
            <span class="count-chip">{{ rows.length }} Members</span>
          </div>

          <v-data-iterator
            :items="rows"
            :items-per-page="-1"
            hide-default-footer
            class="pa-4"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col
                  v-for="item in props.items"
                  :key="item.MemberId"
                  cols="12"
                  sm="6"
                  md="3"
                  lg="2"
                  class="member-col"
                >
                  <div
                    class="member-card"
                    :class="{ inactive: item.ActiveStatus != 1 }"
                  >
                    <div class="member-cover"></div>
                    <div class="d-flex justify-center">
                      <v-avatar size="88" class="member-avatar">
                        <v-img
                          :src="item.ProfilePic"
                          :alt="item.MemberFullname"
                        />
                      </v-avatar>
                    </div>

                    <div class="member-body">
                      <div class="member-name">{{ item.MemberFullname }}</div>
                      <div class="member-id">{{ item.MembershipId }}</div>
                      <span class="member-designation">
                        {{ item.DesignationName }}
                      </span>
                    </div>

                    <div class="member-footer">
                      <v-chip
                        x-small
                        :color="getActiveStatusColor(item.ActiveStatusTxt)"
                        dark
                      >
                        {{ item.ActiveStatusTxt }}
                      </v-chip>

                      <v-btn
                        v-if="
                          item.DesignationId != '' &&
                          editFlag &&
                          item.ActiveStatus != 1
                        "
                        icon
                        color="error"
                        x-small
                        class="ml-2"
                        @click="editData(item)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </div>

        <!-- Important Notes Section -->
        <div class="premium-card fade-up delay-4">
          <div class="card-head">
            <div class="icon-badge icon-badge--amber">
              <v-icon small color="white">mdi-alert</v-icon>
            </div>
            <div class="card-head-title">Important Notes</div>
          </div>

          <div class="notes-grid">
            <div class="note-tile">
              <div class="note-icon">
                <v-icon small color="#1565c0">mdi-account-star</v-icon>
              </div>
              <div>
                <div class="note-title">
                  Assign President, Secretary and IPP first
                </div>
                <div class="note-text">
                  Assign the President, Secretary and IPP before downloading the
                  Nomination committee report, so that their names and
                  membership IDs are filled in the report.
                </div>
              </div>
            </div>

            <div class="note-tile">
              <div class="note-icon">
                <v-icon small color="#1565c0">mdi-account-check</v-icon>
              </div>
              <div>
                <div class="note-title">Active Member Requirement</div>
                <div class="note-text">
                  As per Article 4.2 of policy manual part 2, all elective post
                  members should be active members.
                </div>
              </div>
            </div>

            <div class="note-tile">
              <div class="note-icon">
                <v-icon small color="#1565c0"
                  >mdi-account-card-details-outline</v-icon
                >
              </div>
              <div>
                <div class="note-title">Age Proof Document</div>
                <div class="note-text">
                  All the elective officers should upload their age proof
                  document under their members profile update page.
                </div>
              </div>
            </div>

            <div class="note-tile">
              <div class="note-icon">
                <v-icon small color="#1565c0">mdi-account-multiple-plus</v-icon>
              </div>
              <div>
                <div class="note-title">Member Assignment</div>
                <div class="note-text">
                  To assign LGB members for the next year click on
                  <span class="inline-tag tag-success">Assign Members</span>
                  button.
                </div>
              </div>
            </div>

            <div class="note-tile" v-if="addJcrtButtonFlag">
              <div class="note-icon">
                <v-icon small color="#1565c0">mdi-account-star-outline</v-icon>
              </div>
              <div>
                <div class="note-title">Jayceert Wing Members</div>
                <div class="note-text">
                  To create Jayceert Wing member, click on
                  <span class="inline-tag tag-success">Add Jcrt Member</span>
                  button and after that assign them using the "Assign Members"
                  button.
                </div>
              </div>
            </div>

            <div class="note-tile" v-if="Flag">
              <div class="note-icon">
                <v-icon small color="#1565c0">mdi-account-child</v-icon>
              </div>
              <div>
                <div class="note-title">Junior Jaycee Wing Members</div>
                <div class="note-text">
                  To create Junior Jaycee wing member, click on
                  <span class="inline-tag tag-orange">Add Jr. Jc Member</span>
                  button.
                </div>
              </div>
            </div>

            <div class="note-tile">
              <div class="note-icon">
                <v-icon small color="#1565c0"
                  >mdi-file-document-edit-outline</v-icon
                >
              </div>
              <div>
                <div class="note-title">
                  Nomination Committee Chairman Report
                </div>
                <div class="note-text">
                  Upload the Nomination Committee Chairman Report.
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import NewLgbTeamMembersModify from "@/view/pages/erp/team-members/new-lgb/NewLgbTeamMembersModify.vue";
import NewLgbTeamMembersEdit from "@/view/pages/erp/team-members/new-lgb/NewLgbTeamMembersEdit.vue";
import AddLomDocument from "@/view/pages/erp/team-members/new-lgb/AddLomDocument.vue";
import AddMemberDocument from "@/view/pages/members/AddMemberDocument.vue";
import CreateNewMember from "@/view/pages/erp/team-members/new-lgb/CreateNewMember.vue";

export default {
  mixins: [common],
  components: {
    NewLgbTeamMembersModify,
    NewLgbTeamMembersEdit,
    AddLomDocument,
    AddMemberDocument,
    CreateNewMember,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      dialog: false,
      rows: [],
      tableSelectFlag1: false,
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      refreshButtonFlag: false,
      floatButtonFlag: false,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      editFlag: false,
      addJcrtButtonFlag: false,

      createRecordPrompt: false,
      NewMemberType: "",
      NewMemberPageDescription: "",

      CreateButtonFlag: false,
      PreviewButtonFlag: false,

      TooltipShowFlag: true,

      selectedData: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      uploadRecordPrompt: false,
      uploadDocumentPrompt: false,

      memberDocumentPrompt: false,
      MemberDocumentFlag: false,

      Documentpath: "",

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      FromZoneCodeRules: [(v) => !!v || "Zone is required"],
      FromZoneCode: "",
      FromZoneCodeOptions: [],
      FromZoneCodeOptionsLoading: false,

      FromLomCodeRules: [(v) => !!v || "LO is required"],
      FromLomCode: "",
      FromLomCodeOptions: [],
      FromLomCodeOptionsLoading: false,

      ToZoneCodeRules: [(v) => !!v || "Zone is required"],
      ToZoneCode: "",
      ToZoneCodeOptions: [],
      ToZoneCodeOptionsLoading: false,

      ToLomCodeRules: [(v) => !!v || "LO is required"],
      ToLomCode: "",
      ToLomCodeOptions: [],
      ToLomCodeOptionsLoading: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LO" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      SampleFilePath: "",
      ReportLoadingFlag: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {
    KeyPostStatus() {
      // President (4), Secretary (23) and IPP (25) should be assigned first
      var posts = [
        { DesignationId: 4, Name: "President" },
        { DesignationId: 23, Name: "Secretary" },
        { DesignationId: 25, Name: "IPP" },
      ];
      var rows = this.rows;
      return posts.map((post) => ({
        ...post,
        AssignedFlag: rows.some(
          (row) => row.DesignationId == post.DesignationId
        ),
      }));
    },
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath =
          server_url + "assets/sample/nomination_committee_report.pdf";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;

        this.pageData();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "lgb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
      this.getDocumentRecords();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      console.log({ flag });
      this.addRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    hideMemberDocumentPrompt() {
      console.log("hideMemberDocumentPrompt called");
      this.memberDocumentPrompt = false;
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      console.log({ flag });
      this.editRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    hideUploadRecordPrompt(flag) {
      console.log("hideUploadRecordPrompt called");
      console.log({ flag });
      this.uploadDocumentPrompt = false;
      if (flag) {
        this.getDocumentRecords();
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    OpenNewMemberDialog(id) {
      console.log("OpenNewMemberDialog called id=" + id);
      var NewMemberType = "";
      var NewMemberPageDescription = "";
      switch (id) {
        case 1:
          // Jayceert Wing

          NewMemberType = 8;
          NewMemberPageDescription = "Add member for Jayceert Wing";
          break;

        case 2:
          // Junior Jaycee Wing

          NewMemberType = 9;
          NewMemberPageDescription = "Add member for Junior Jaycee Wing";
          break;

        default:
          break;
      }
      console.log(
        "NewMemberType=" +
          NewMemberType +
          ", NewMemberPageDescription=" +
          NewMemberPageDescription
      );
      this.NewMemberType = NewMemberType;
      this.NewMemberPageDescription = NewMemberPageDescription;
      this.createRecordPrompt = true;
    },
    hideCreateRecordPrompt(flag) {
      console.log("hideCreateRecordPrompt called");
      console.log({ flag });
      this.createRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
        /*
        var url = "/members/subscription/assign";
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
        */
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      var CurrentYearId = this.CurrentYearId;
      console.log("CurrentYearId=" + CurrentYearId);

      if (LomCode != null && CurrentYearId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/lists";
        var upload = {
          UserInterface: 1,
          OrganizationTypeId: 3,
          LomCode: LomCode,
          YearCode: CurrentYearId,
          ExceptDesignationId: [1, 5, 7],
          DirectoryInformationFlag: true,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.rows = [];
        this.ResultFlag = false;
        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableSelectFlag1 = records.TableSelectFlag;
              thisIns.editFlag = records.TableEditFlag;
              thisIns.MemberDocumentFlag = records.MemberDocumentFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    getDocumentRecords() {
      console.log("getDocumentRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      var CurrentYearId = this.CurrentYearId;
      console.log("CurrentYearId=" + CurrentYearId);

      if (LomCode != null && CurrentYearId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/show";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            var options = response.data.options;
            console.log("output=" + output + ", flag=" + flag);

            // thisIns.CreateButtonFlag = TableOptions.CreateButtonFlag;
            // thisIns.PreviewButtonFlag = TableOptions.PreviewButtonFlag;

            if (flag == 1) {
              var Documentpath = records.DocumentAssetPath;
              console.log("Documentpath=" + Documentpath);
              thisIns.Documentpath = Documentpath;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    downloadNominationReport() {
      console.log("downloadNominationReport called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      var CurrentYearId = this.CurrentYearId;
      console.log("CurrentYearId=" + CurrentYearId);

      if (LomCode != "" && CurrentYearId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/year-wise-designation/nomination-committee-report";
        var upload = {
          UserInterface: 1,
          LomCode: LomCode,
          YearCode: CurrentYearId,
        };
        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        this.ReportLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.ReportLoadingFlag = false;

            var flag = response.data.flag;
            var output = response.data.output;
            var records = response.data.records;

            if (flag == 1) {
              window.open(records.FilePath, "_blank");
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ReportLoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
$primary-dark: #0b2a5b;
$primary: #1565c0;
$accent: #00b4d8;
$success: #16a34a;
$warning: #f59e0b;
$surface: #ffffff;
$page-bg: #f4f7fb;
$border: #e3e8ef;
$text-strong: #0f172a;
$text-muted: #64748b;
$shadow-soft: 0 1px 2px rgba(15, 23, 42, 0.06),
  0 8px 24px rgba(15, 23, 42, 0.06);
$shadow-strong: 0 2px 4px rgba(15, 23, 42, 0.08),
  0 16px 32px rgba(15, 23, 42, 0.14);
$header-gradient: linear-gradient(
  135deg,
  $primary-dark 0%,
  $primary 60%,
  $accent 100%
);

@keyframes lgbFadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lgbFadeIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes lgbPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.55);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
}

@keyframes lgbFloat {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(12px, -10px);
  }
}

#new-lgb-team-members-list {
  .premium-header {
    position: relative;
    overflow: hidden;
    background: $header-gradient;
    color: #ffffff;
    padding: 22px 24px;

    .header-orb {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.12);
      filter: blur(2px);
      pointer-events: none;
      animation: lgbFloat 9s ease-in-out infinite;
    }

    .orb-1 {
      width: 220px;
      height: 220px;
      top: -110px;
      right: -40px;
    }

    .orb-2 {
      width: 140px;
      height: 140px;
      bottom: -80px;
      right: 22%;
      background: rgba(0, 180, 216, 0.22);
      animation-delay: 1.5s;
    }

    .orb-3 {
      width: 90px;
      height: 90px;
      top: 10px;
      left: 38%;
      background: rgba(255, 255, 255, 0.07);
      animation-delay: 3s;
    }

    .header-inner {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
    }

    .header-left {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .glass-icon {
      flex: 0 0 48px;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 14px;
      background: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.25);
      backdrop-filter: blur(8px);
      animation: lgbFadeIn 0.5s ease-out both;

      &.glass-icon--sm {
        flex-basis: 38px;
        width: 38px;
        height: 38px;
      }
    }

    .header-title {
      font-size: 1.4rem;
      font-weight: 700;
      letter-spacing: 0.3px;
      line-height: 1.25;
      margin: 0;
      color: #ffffff;

      &.header-title--sm {
        font-size: 1.1rem;
      }
    }

    .header-subtitle {
      font-size: 0.85rem;
      opacity: 0.85;
      margin-top: 2px;
    }

    .glass-btn {
      height: 40px !important;
      border-radius: 10px !important;
      background: rgba(255, 255, 255, 0.16) !important;
      border: 1px solid rgba(255, 255, 255, 0.35);
      backdrop-filter: blur(8px);
      transition: transform 0.2s, box-shadow 0.2s, background 0.2s;

      &:hover {
        transform: translateY(-2px);
        background: rgba(255, 255, 255, 0.26) !important;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
      }
    }

    &.premium-header--dialog {
      padding: 16px 20px;
      position: sticky;
      top: 0;
      z-index: 5;
    }
  }

  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  .lgb-shell {
    border-radius: 14px !important;
    overflow: hidden;
    box-shadow: $shadow-soft !important;
  }

  .lgb-body {
    background-color: $page-bg;
    padding: 24px !important;
    font-size: 14px;
    color: $text-strong;

    @media (max-width: 600px) {
      padding: 12px !important;
    }
  }

  // Staggered section entrance
  .fade-up {
    animation: lgbFadeUp 0.4s ease-out both;

    &.delay-1 {
      animation-delay: 0ms;
    }
    &.delay-2 {
      animation-delay: 80ms;
    }
    &.delay-3 {
      animation-delay: 160ms;
    }
    &.delay-4 {
      animation-delay: 240ms;
    }
  }

  .premium-card {
    background: $surface;
    border: 1px solid $border;
    border-radius: 14px;
    box-shadow: $shadow-soft;
    overflow: hidden;
  }

  .card-head {
    display: flex;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid $border;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);

    .card-head-title {
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: 0.2px;
      color: $text-strong;
    }
  }

  .icon-badge {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    background: linear-gradient(135deg, $primary 0%, $accent 100%);
    box-shadow: 0 4px 10px rgba(21, 101, 192, 0.3);

    &.icon-badge--amber {
      background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
      box-shadow: 0 4px 10px rgba(245, 158, 11, 0.3);
    }
  }

  .count-chip {
    font-size: 12px;
    font-weight: 600;
    color: $primary;
    background: rgba(21, 101, 192, 0.08);
    border: 1px solid rgba(21, 101, 192, 0.2);
    border-radius: 8px;
    padding: 3px 10px;
  }

  // Stepper
  .stepper {
    display: flex;
    gap: 16px;
    padding: 20px 18px;

    @media (max-width: 960px) {
      flex-direction: column;
    }
  }

  .step {
    position: relative;
    flex: 1 1 0;
    display: flex;
    flex-direction: column;

    @media (max-width: 960px) {
      flex-direction: row;
    }

    // connector line between steps (desktop only)
    &:not(:last-child)::after {
      content: "";
      position: absolute;
      top: 18px;
      left: calc(50% + 26px);
      width: calc(100% - 52px + 16px);
      height: 2px;
      background: linear-gradient(90deg, $primary 0%, $border 100%);

      @media (max-width: 960px) {
        display: none;
      }
    }

    .step-marker {
      display: flex;
      justify-content: center;
      margin-bottom: 12px;

      @media (max-width: 960px) {
        margin: 0 12px 0 0;
      }
    }

    .step-circle {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      color: #ffffff;
      background: linear-gradient(135deg, $primary 0%, $accent 100%);
      box-shadow: 0 4px 12px rgba(21, 101, 192, 0.35);
      position: relative;
      z-index: 1;
    }

    &.step--pending .step-circle {
      animation: lgbPulse 2s infinite;
    }

    .step-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 16px;
      border: 1px solid $border;
      border-radius: 12px;
      background: #fbfcfe;
      transition: box-shadow 0.2s, transform 0.2s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: $shadow-soft;
      }
    }

    .step-title {
      font-size: 0.95rem;
      font-weight: 700;
      color: $text-strong;
      margin-bottom: 6px;
    }

    .step-text {
      font-size: 13px;
      line-height: 1.6;
      color: $text-muted;
    }

    .step-footer {
      margin-top: auto;
      padding-top: 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }
  }

  .pill-chip {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 999px;
    transition: transform 0.2s, opacity 0.2s;

    &.pill-chip--done {
      color: #15803d;
      background: rgba(22, 163, 74, 0.1);
      border: 1px solid rgba(22, 163, 74, 0.3);
    }

    &.pill-chip--pending {
      color: #b45309;
      background: rgba(245, 158, 11, 0.1);
      border: 1px solid rgba(245, 158, 11, 0.35);
    }
  }

  .outline-link {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: $primary !important;
    text-decoration: none !important;
    border: 1px solid rgba(21, 101, 192, 0.4);
    border-radius: 10px;
    padding: 6px 12px;
    background: #ffffff;
    transition: transform 0.2s, box-shadow 0.2s, background 0.2s;

    &:hover {
      transform: translateY(-2px);
      background: rgba(21, 101, 192, 0.05);
      box-shadow: 0 4px 12px rgba(21, 101, 192, 0.15);
    }
  }

  .inline-tag {
    display: inline-block;
    padding: 0 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.7;
    color: #ffffff;

    &.tag-success {
      background: $success;
    }
    &.tag-teal {
      background: #009688;
    }
    &.tag-orange {
      background: #fb8c00;
    }
  }

  // Action toolbar
  .action-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .action-btn {
    height: 40px !important;
    border-radius: 10px !important;
    text-transform: none;
    letter-spacing: 0.2px;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18) !important;
    }
  }

  .btn-shine {
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -75%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        120deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.45) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: skewX(-20deg);
      transition: left 0.6s ease;
    }

    &:hover::after {
      left: 125%;
    }
  }

  // KPI status card
  .kpi-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid $border;
    border-left-width: 4px;
    border-radius: 12px;
    background: #ffffff;

    @media (max-width: 1264px) {
      margin-top: 12px;
    }

    &.kpi-card--done {
      border-left-color: $success;
      .kpi-avatar {
        background: rgba(22, 163, 74, 0.1);
      }
    }

    &.kpi-card--pending {
      border-left-color: $warning;
      .kpi-avatar {
        background: rgba(245, 158, 11, 0.12);
      }
    }

    .kpi-avatar {
      width: 40px;
      height: 40px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
    }

    .kpi-label {
      font-size: 14px;
      font-weight: 700;
      color: $text-strong;
    }

    .kpi-sub {
      font-size: 12px;
      color: $text-muted;
    }

    .status-chip {
      border-radius: 8px !important;
    }
  }

  .chip-pop-enter-active,
  .chip-pop-leave-active {
    transition: transform 0.25s ease, opacity 0.25s ease;
  }

  .chip-pop-enter,
  .chip-pop-leave-to {
    opacity: 0;
    transform: scale(0.8);
  }

  // Member cards
  .member-col {
    animation: lgbFadeUp 0.45s ease-out both;

    @for $i from 1 through 24 {
      &:nth-child(#{$i}) {
        animation-delay: #{$i * 50}ms;
      }
    }
  }

  .member-card {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid $border;
    border-radius: 14px;
    box-shadow: $shadow-soft;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-6px);
      box-shadow: $shadow-strong;

      .member-cover {
        background-position: 100% 50%;
      }
    }

    &.inactive {
      opacity: 0.7;
    }

    .member-cover {
      height: 72px;
      background: linear-gradient(
        120deg,
        $primary-dark,
        $primary,
        $accent,
        $primary
      );
      background-size: 300% 100%;
      background-position: 0% 50%;
      transition: background-position 0.8s ease;
    }

    .member-avatar {
      margin-top: -44px;
      border: 4px solid #ffffff;
      box-shadow: 0 6px 16px rgba(15, 23, 42, 0.2);
      background: #ffffff;
    }

    .member-body {
      flex: 1;
      text-align: center;
      padding: 10px 12px 8px;
    }

    .member-name {
      font-size: 14px;
      font-weight: 700;
      color: $text-strong;
      line-height: 1.3;
    }

    .member-id {
      font-size: 12px;
      color: $text-muted;
      margin-top: 2px;
    }

    .member-designation {
      display: inline-block;
      margin-top: 8px;
      font-size: 12px;
      font-weight: 600;
      color: $primary;
      background: rgba(21, 101, 192, 0.08);
      border-radius: 999px;
      padding: 3px 10px;
    }

    .member-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 12px;
      border-top: 1px solid $border;
      background: #fbfcfe;
    }
  }

  // Important notes
  .notes-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 18px;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
    }
  }

  .note-tile {
    display: flex;
    align-items: flex-start;
    padding: 14px;
    border: 1px solid $border;
    border-radius: 12px;
    background: #fbfcfe;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: $shadow-soft;
    }

    .note-icon {
      flex: 0 0 34px;
      height: 34px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      background: rgba(21, 101, 192, 0.1);
    }

    .note-title {
      font-size: 14px;
      font-weight: 700;
      color: $text-strong;
      margin-bottom: 4px;
    }

    .note-text {
      font-size: 13px;
      line-height: 1.6;
      color: $text-muted;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none !important;
      transition: none !important;
    }
  }
}

.premium-dialog {
  border-radius: 14px !important;

  .premium-header {
    position: relative;
    overflow: hidden;
    background: $header-gradient;
    color: #ffffff;
    padding: 22px 24px;

    .header-orb {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.12);
      filter: blur(2px);
      pointer-events: none;
      animation: lgbFloat 9s ease-in-out infinite;
    }

    .orb-1 {
      width: 220px;
      height: 220px;
      top: -110px;
      right: -40px;
    }

    .orb-2 {
      width: 140px;
      height: 140px;
      bottom: -80px;
      right: 22%;
      background: rgba(0, 180, 216, 0.22);
      animation-delay: 1.5s;
    }

    .orb-3 {
      width: 90px;
      height: 90px;
      top: 10px;
      left: 38%;
      background: rgba(255, 255, 255, 0.07);
      animation-delay: 3s;
    }

    .header-inner {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
    }

    .header-left {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .glass-icon {
      flex: 0 0 48px;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 14px;
      background: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.25);
      backdrop-filter: blur(8px);
      animation: lgbFadeIn 0.5s ease-out both;

      &.glass-icon--sm {
        flex-basis: 38px;
        width: 38px;
        height: 38px;
      }
    }

    .header-title {
      font-size: 1.4rem;
      font-weight: 700;
      letter-spacing: 0.3px;
      line-height: 1.25;
      margin: 0;
      color: #ffffff;

      &.header-title--sm {
        font-size: 1.1rem;
      }
    }

    .header-subtitle {
      font-size: 0.85rem;
      opacity: 0.85;
      margin-top: 2px;
    }

    .glass-btn {
      height: 40px !important;
      border-radius: 10px !important;
      background: rgba(255, 255, 255, 0.16) !important;
      border: 1px solid rgba(255, 255, 255, 0.35);
      backdrop-filter: blur(8px);
      transition: transform 0.2s, box-shadow 0.2s, background 0.2s;

      &:hover {
        transform: translateY(-2px);
        background: rgba(255, 255, 255, 0.26) !important;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
      }
    }

    &.premium-header--dialog {
      padding: 16px 20px;
      position: sticky;
      top: 0;
      z-index: 5;
    }
  }

  .premium-dialog-card {
    border-radius: 14px !important;
    overflow: hidden;
  }

  .preview-body {
    padding: 16px;
    background: $page-bg;
  }

  .preview-frame {
    border: 1px solid $border;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: $shadow-soft;
    background: repeating-linear-gradient(
      45deg,
      #f8fafc,
      #f8fafc 10px,
      #eef2f7 10px,
      #eef2f7 20px
    );

    iframe {
      display: block;
      border: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none !important;
      transition: none !important;
    }
  }
}
</style>
